module.exports = __webpack_public_path__ + "static/media/graphic-library-start.4b7fcbe8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/graphic-library-start.svg
// module id = 644
// module chunks = 0